export default __webpack_public_path__ + "static/media/Tutorial.a10f2bcf.svg";